export default (startDate, language = null) => ({
  date: null,
  days: 0,
  hours: 0,
  minutes: 0,
  seconds: 0,
  interval: null,
  forcedLanguage: language,

  // Czech translations with proper grammar rules
  translations: {
    cs: {
      day: '{0} dnů|{1} den|[2, 4] dny|[5,*] dnů',
      hour: '{0} hodin|{1} hodina|[2, 4] hodiny|[5,*] hodin',
      minute: '{0} minut|{1} minuta|[2, 4] minuty|[5,*] minut',
      second: '{0} vteřin|{1} vteřina|[2, 4] vteřiny|[5,*] vteřin'
    },
    en: {
      day: '{0} days|{1} day|[2,*] days',
      hour: '{0} hours|{1} hour|[2,*] hours',
      minute: '{0} minutes|{1} minute|[2,*] minutes',
      second: '{0} seconds|{1} second|[2,*] seconds'
    },
    sk: {
      day: '{0} dní|{1} deň|[2, 4] dni|[5,*] dní',
      hour: '{0} hodín|{1} hodina|[2, 4] hodiny|[5,*] hodín',
      minute: '{0} minút|{1} minúta|[2, 4] minúty|[5,*] minút',
      second: '{0} sekúnd|{1} sekunda|[2, 4] sekundy|[5,*] sekúnd'
    }
  },

  init() {
    this.date = new Date(startDate);
    this.calculateTimeRemaining();

    // Update countdown every second
    this.interval = setInterval(() => {
      this.calculateTimeRemaining();
    }, 1000);
  },

  // Get current language (you can modify this based on your language detection logic)
  getCurrentLanguage() {
    // If language is forced, use it
    if (this.forcedLanguage) {
      return this.forcedLanguage;
    }

    // Default to Czech
    return 'cs';
  },

  // Helper function to get translated time unit with proper grammar
  getTranslatedUnit(value, unitKey) {
    const lang = this.getCurrentLanguage();
    const langTranslations = this.translations[lang] || this.translations.cs;
    const translation = langTranslations[unitKey];

    if (!translation) {
      return value;
    }

    const parts = translation.split('|');

    if (parts.length === 1) {
      return `${value} ${parts[0]}`;
    }

    // Handle Czech/Slovak grammar rules
    if (value === 0) {
      return parts[0].replace('{0}', value);
    } else if (value === 1) {
      return parts[1].replace('{1}', value);
    } else if (value >= 2 && value <= 4) {
      return parts[2].replace('[2, 4]', value);
    } else {
      return parts[3].replace('[5,*]', value);
    }
  },

  // Get formatted time display (without seconds)
  getFormattedTime() {
    const dayText = this.getTranslatedUnit(this.days, 'day');
    const hourText = this.getTranslatedUnit(this.hours, 'hour');
    const minuteText = this.getTranslatedUnit(this.minutes, 'minute');

    return `${dayText}: ${hourText}: ${minuteText}:`;
  },

  // Get seconds number only
  getSecondsNumber() {
    return this.seconds;
  },

  // Get seconds text only (without the number)
  getSecondsText() {
    const lang = this.getCurrentLanguage();
    const langTranslations = this.translations[lang] || this.translations.cs;
    const translation = langTranslations.second;

    if (!translation) {
      return '';
    }

    const parts = translation.split('|');

    if (parts.length === 1) {
      return parts[0].replace('{0}', '').trim();
    }

    // Handle Czech/Slovak grammar rules
    if (this.seconds === 0) {
      return parts[0].replace('{0}', '').trim();
    } else if (this.seconds === 1) {
      return parts[1].replace('{1}', '').trim();
    } else if (this.seconds >= 2 && this.seconds <= 4) {
      return parts[2].replace('[2, 4]', '').trim();
    } else {
      return parts[3].replace('[5,*]', '').trim();
    }
  },

  calculateTimeRemaining() {
    const now = new Date();
    const timeRemaining = this.date - now;

    if (timeRemaining <= 0) {
      // Countdown has ended
      this.days = 0;
      this.hours = 0;
      this.minutes = 0;
      this.seconds = 0;

      // Clear the interval when countdown ends
      if (this.interval) {
        clearInterval(this.interval);
      }
      return;
    }

    // Calculate days, hours, minutes, and seconds
    const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

    this.days = days;
    this.hours = hours;
    this.minutes = minutes;
    this.seconds = seconds;
  },
});
